(function () {
  var media = window.matchMedia && window.matchMedia('(max-width: 749px)');
  if (media && !media.matches) return;

  function shouldPatch(url) {
    return url.origin === window.location.origin &&
      /^\/products\/[^/?#]+\/?$/.test(url.pathname) &&
      !url.searchParams.has('view');
  }

  function productUrlWithView(href) {
    try {
      var url = new URL(href, window.location.origin);
      if (!shouldPatch(url)) return null;
      url.searchParams.set('view', 'reviewfix');
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return null;
    }
  }

  function patchLinks(root) {
    (root || document).querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      var next = productUrlWithView(link.getAttribute('href'));
      if (next) link.setAttribute('href', next);
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest && event.target.closest('a[href*="/products/"]');
    if (!link) return;
    var next = productUrlWithView(link.getAttribute('href'));
    if (next) link.setAttribute('href', next);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { patchLinks(document); });
  } else {
    patchLinks(document);
  }

  setTimeout(function () { patchLinks(document); }, 500);
  setTimeout(function () { patchLinks(document); }, 1800);

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes && mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) patchLinks(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
